<template>
  <div class="onboarding-status" v-if="hasIncompleteSteps">
    <StepsList :home-mode="true" :compact-mode="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createStepsArray } from '@/views/launch/config/stepsConfig.js';
import StepsList from '@/views/launch/components/StepsList.vue';
import { PROGRAMS } from '@/access/programs';

export default {
  name: 'HomeOnboardingStatus',
  components: {
    StepsList,
  },
  computed: {
    ...mapGetters('users', [
      'hasAchievement',
      'achievementsLoaded',
      'currentUser',
    ]),
    ...mapGetters('programs', {
      getProgram: 'getProgram',
      programsLoaded: 'loaded',
    }),
    ...mapGetters('teams', ['currentTeam']),

    isSMSEnabled() {
      const program = this.getProgram(PROGRAMS.PRODUCTS_SMS);
      if (!this.programsLoaded || !program) return true;
      return program?.enabled;
    },

    isUserActivated() {
      return this.currentUser?.activated || false;
    },

    // Mirrors SetPhoneLineWarning.isTextingNumberSet: in a team context the phone
    // is always on the team — user credentials are not a fallback.
    hasSmsLineConfigured() {
      if (this.currentTeam) {
        return !!this.currentTeam.twilio_phone;
      }
      const { twilio_sid, twilio_ms_id, twilio_phone } = this.currentUser || {};
      return !!(twilio_sid && (twilio_phone || twilio_ms_id));
    },

    isDataReady() {
      return this.achievementsLoaded && this.programsLoaded;
    },

    incompleteStepsCount() {
      if (!this.isDataReady) return 0;

      const steps = createStepsArray(
        this.isSMSEnabled,
        true,
        this.isUserActivated
      );

      const incompleteSteps = steps.filter((step) => {
        if (step.id === 'finish') return false;
        if (step.event && this.hasAchievement(step.event)) return false;
        if (step.id === 'sms' && this.hasSmsLineConfigured) return false;
        return true;
      });

      return incompleteSteps.length;
    },

    hasIncompleteSteps() {
      if (!this.currentUser?.owner) return false;
      return this.incompleteStepsCount > 0;
    },
  },
};
</script>
